/* ── PROOFING ROUTES (Milestone 2, 2026-10-06) ─────────────────────────────────
   The app has no router; like `?admin=1`, proofing is reached by query string. The
   Airtable job carries the links (formula fields on {SFMC Asset ID}):
     Review link  ?proof=<assetId>            Review Email — divisions comment
     Editor link  ?proof=<assetId>&mode=edit  Edit Email — a commenter who opens it lands on Review Email
   A URL decides which screen loads, never what anyone may do: the server checks every action. */

const ID_RE = /^\d{4,12}$/;

/* ── ON EVERYWHERE, PROD INCLUDED (Jack, 2026-10-29) ─────────────────────────────────
   Proofing was dev/QA/UAT-only from 10-19, keyed off the host like the hero overlay. Jack:
   proofing is not to be hidden in prod. So it is on by default on every host, and a
   ?proof= link on emailbuilder.lennar.com opens Review / Edit Email. The server still
   checks every action. `window.__APP_CONFIG__.features.proofing = false` turns it off for
   one environment without a build. */
export function proofingEnabled(_loc?: { hostname: string; protocol: string }): boolean {
  try {
    const f = (typeof window !== "undefined" ? (window as unknown as { __APP_CONFIG__?: { features?: Record<string, unknown> } }).__APP_CONFIG__ : undefined)?.features;
    if (f && typeof f.proofing === "boolean") return f.proofing;
  } catch { /* no config */ }
  return true;
}

export interface ProofRoute { id: string; mode: "review" | "edit" }

export function proofRouted(search: string = typeof window !== "undefined" ? window.location.search : "", loc?: { hostname: string; protocol: string }): ProofRoute | null {
  if (!proofingEnabled(loc)) return null;
  try {
    const qs = new URLSearchParams(search);
    const id = (qs.get("proof") || "").trim();
    if (!qs.has("proof")) return null;
    return { id: ID_RE.test(id) ? id : "", mode: (qs.get("mode") || "").toLowerCase() === "edit" ? "edit" : "review" };
  } catch { return null; }
}

/* keep a local `?as=` (dev identity) on in-app links so clicking through doesn't drop it */
function asParam(): string {
  try { const a = new URLSearchParams(window.location.search).get("as"); return a ? "&as=" + encodeURIComponent(a) : ""; } catch { return ""; }
}

export function proofReviewUrl(id: string, edit = false): string {
  return "?proof=" + encodeURIComponent(id) + (edit ? "&mode=edit" : "") + asParam();
}
